import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function HomeVastuSelection() {
  const navigate = useNavigate();
  return (
    <div className="mx-auto p-3" style={{ maxWidth: 720 }}>
      {/* Om icon + heading */}
      <div className="text-center mb-3">
        <div className="d-flex justify-content-center mb-2">
          <div
            className="rounded-circle d-flex align-items-center justify-content-center shadow"
            style={{ width: 64, height: 64, background: "#7B1E1E" }}
          >
            <svg width="44" height="44" viewBox="0 0 64 64" fill="none">
              <text
                x="50%"
                y="56%"
                textAnchor="middle"
                fontSize="35"
                fontFamily="Noto Serif, serif"
                fill="#C8860A"
                dominantBaseline="middle"
              >
                ॐ
              </text>
            </svg>
          </div>
        </div>
        <h1
          className="fw-bold mb-2"
          style={{
            fontFamily: "'Cormorant Garamond', serif",
            color: "#7B1E1E",
            fontSize: "2.4rem",
          }}
        >
          Home Vastu Analysis
        </h1>
        <p
          className="mx-auto mb-0"
          style={{ maxWidth: 380, color: "#8B6A4F", fontSize: "0.9rem" }}
        >
          Ancient wisdom meets modern AI to reveal the Vastu energy of your home
        </p>
      </div>

      {/* Choice cards */}
      <Row className="g-4">
        <Col md={6}>
          <button
            onClick={() => navigate("/homeImage")}
            className="w-100 h-100 text-start bg-white rounded-4 p-4 shadow-sm"
            style={{ border: "2px solid #C8860A", transition: "all .2s ease" }}
          >
            <div
              className="rounded-3 d-flex align-items-center justify-content-center mb-3 fs-3"
              style={{ width: 48, height: 48, background: "#FFF3DC" }}
            >
              🏠
            </div>
            <span
              className="d-inline-block text-uppercase fw-bold rounded-pill px-2 py-1 mb-2"
              style={{
                fontSize: 10,
                background: "#C8860A",
                color: "#fff",
                letterSpacing: "0.05em",
              }}
            >
              Recommended
            </span>
            <h3
              className="fw-bold fs-4 mb-2"
              style={{
                fontFamily: "'Cormorant Garamond', serif",
                color: "#7B1E1E",
              }}
            >
              Image Based Analysis
            </h3>
            <p className="small mb-3" style={{ color: "#8B6A4F" }}>
              Upload your house plan and let our AI detect, analyze, and
              generate a comprehensive Vastu report automatically.
            </p>
            <div className="small fw-semibold" style={{ color: "#C8860A" }}>
              Get Started →
            </div>
          </button>
        </Col>

        <Col md={6}>
          <button
            onClick={() => navigate("/homevasthu")}
            className="w-100 h-100 text-start bg-white rounded-4 p-4 shadow-sm"
            style={{ border: "2px solid #E8D8C4", transition: "all .2s ease" }}
          >
            <div
              className="rounded-3 d-flex align-items-center justify-content-center mb-3 fs-3"
              style={{ width: 48, height: 48, background: "#F5EFE6" }}
            >
              📋
            </div>
            <h3
              className="fw-bold fs-4 mb-2"
              style={{
                fontFamily: "'Cormorant Garamond', serif",
                color: "#7B1E1E",
              }}
            >
              Manual Data Entry
            </h3>
            <p className="small mb-3" style={{ color: "#8B6A4F" }}>
              Enter your home details manually and receive a Vastu assessment
              based on the information you provide.
            </p>
            <div className="small fw-semibold" style={{ color: "#7B1E1E" }}>
              Continue →
            </div>
          </button>
        </Col>
      </Row>
    </div>
  );
}
